import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>TradingCard.Life</h3>
          <p>Your trading card collection manager</p>
        </div>
        
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/trading-card-sets">Trading Card Sets</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Help</h3>
          <ul>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/cookie-policy">Cookie Policy</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {currentYear} TradingCard.Life - All rights reserved</p>
        <p>All trading-card images are copyrighted by their rightful owners and are used here for informational purposes only. This website has no affiliation with any trading card companies.</p>
      </div>
    </footer>
  );
};

export default Footer;